export enum ProfileModals {
  MessageToWorkforce = 'MessageToWorkforce',
}
